import { Outlet } from 'react-router-dom';
import { AbilityContext, ability, ErrorBoundary } from 'app/atoms';
import Auth from 'app/modules/Auth/Auth';
import DashboardLayout from 'app/molecules/Layout/dashboard';
import { NavBreadcrumbProvider } from 'app/molecules/NavBreadcrumb/NavBreadcrumbContext';

const Pages = () => {
  return (
    <Auth>
      <AbilityContext.Provider value={ability}>
        <NavBreadcrumbProvider>
          <DashboardLayout>
            <ErrorBoundary compact>
              <Outlet />
            </ErrorBoundary>
          </DashboardLayout>
        </NavBreadcrumbProvider>
      </AbilityContext.Provider>
    </Auth>
  );
};

export default Pages;
